// Moved to shared-libs so the data is shared between webapp and mobile.
// New consumers should import from `shared-libs/helpers/countries` directly.
export { default } from 'shared-libs/helpers/countries'
